import { render } from "./APIView.vue?vue&type=template&id=86f97b44"
import script from "./APIView.vue?vue&type=script&lang=js"
export * from "./APIView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__